const checkFlightItineraryPrivateFare = (flightItinerary, fare = undefined) => {
  let selectedFare = fare;
  if (!selectedFare) {
    const firstFlight = flightItinerary?.flightSegments?.[0]?.flights?.[0];
    selectedFare = firstFlight?.selectedFare;
  }
  return selectedFare?.farePassengerInfo?.some((p) => p.privateFare);
};

export default checkFlightItineraryPrivateFare;
